import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../../components/atoms/Navbar";
import logo from "../../../assets/images/blitz_logo.svg";
import Button from "../../../components/atoms/Button";
import style from "./style.module.css";

const NotFound = () => {
  return (
    <div className={style.container}>
      <Navbar noLogo={false} logo={logo} />
      <section className={style.content}>
        <h1 className={style.title}>404</h1>
        <p className={style.message}>Page not found</p>
        <p className={style.subtext}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button text="Back to home" />
        </Link>
      </section>
    </div>
  );
};

export default NotFound;
